import { useDomainType } from './useDomainType'

export interface SupportContactData {
  username: string
  telegramUrl: string
  displayName: string
}

export const useSupportContact = (): SupportContactData => {
  const domainType = useDomainType()

  if (domainType === 'payx') {
    return {
      username: '@PayX_administrator',
      telegramUrl: 'https://t.me/PayX_administrator',
      displayName: '@PayX_administrator'
    }
  }

  if (domainType === 'yellowpay') {
    return {
      username: '@YellowPay_support',
      telegramUrl: 'https://t.me/YellowPay_support',
      displayName: '@YellowPay_support'
    }
  }

  // Default to syncra
  return {
    username: '@COO_Syncra',
    telegramUrl: 'https://t.me/COO_Syncra',
    displayName: '@COO_Syncra'
  }
}
